import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  DigitalSubmissionString,
  GroundTruthString,
} from '../../../redux/types';
import { Colors } from '../../utilities/Colors';

type Props = {
  exerciseGroundTruth: GroundTruthString;
  submission?: DigitalSubmissionString;
}

function stringScoreEvaluation(gtPayload: GroundTruthString['payload'], userAnswer: DigitalSubmissionString['answer']): { score: number, status: 'correct'|'acceptable'|'wrong' } {
  let answerMeta: { score: number, status: 'correct'|'acceptable'|'wrong' } = { score: 0, status: 'wrong' };
  let { answer } = userAnswer;
  if (!userAnswer || !answer || !answer.trim()) {
    return answerMeta;
  }
  answer = answer.trim();
  const highestScore = Math.max(...gtPayload.map((ob) => ob.score));
  const scores = gtPayload.map((gtOpt) => {
    const gtText = gtOpt.text.trim();
    if (!gtOpt.caseSensitive) {
      if (gtText.toLowerCase() === answer.toLowerCase()) {
        return gtOpt.score;
      }
    }
    if (gtText === answer) {
      return gtOpt.score;
    }
    return 0;
  });
  if (scores) {
    const highestUserScore = Math.max(...scores);
    let status: 'correct'|'acceptable'|'wrong' = 'wrong';
    if (highestUserScore !== 0) {
      status = highestUserScore === highestScore ? 'correct' : 'acceptable';
    }
    answerMeta = { score: highestUserScore, status };
  }
  return answerMeta;
}

const RevealedAnsString: React.FC<Props> = ({
  exerciseGroundTruth,
  submission,
}: Props) => {
  const evaluateString = (gt: GroundTruthString, sb?: DigitalSubmissionString) => {
    const { status } = stringScoreEvaluation(gt.payload, sb?.answer || { answer: '' });
    return status;
  };

  const finalAnswer = evaluateString(exerciseGroundTruth, submission);

  return (
    <Box aria-label="exercise-answer-string">
      {
        finalAnswer !== null && finalAnswer !== undefined && (
          <Box>
            {
              finalAnswer === 'wrong' && (
                <Typography style={{ color: Colors.wrong, fontWeight: 500 }} component="div">Wrong Answer</Typography>
              )
            }
            {
              (finalAnswer === 'acceptable') && (
                <Typography style={{ color: Colors.acceptable, fontWeight: 500 }} component="div">Acceptable Answer</Typography>
              )
            }
            {
              (finalAnswer === 'correct') && (
                <Typography style={{ color: Colors.correct, fontWeight: 500 }} component="div">Correct Answer</Typography>
              )
            }
          </Box>
        )
      }
      {
        exerciseGroundTruth.payload.map((gt, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index} display="flex" gap={2}>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              color="GrayText"
              maxWidth={250}
            >
              {gt.text}
            </Typography>
            <Typography fontWeight={500}>{gt.caseSensitive ? 'case sensitive' : ''}</Typography>
          </Box>
        ))
      }
    </Box>
  );
};

export default RevealedAnsString;
